define('presentation/account/sidebar/presentationObjects/userWithPendingTicketsPresentationObject',[], function () {
    return function () {
        var self = this;
        self.displayName = null;
        self.viewTicketsUrl = null;
        self.pendingTicketCount = null;
    };
});
